// Trendyol Sipariş Bildirim (webhook) Ayarları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.trendyolWebhook';

export const trendyolWebhookSettingsGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Sipariş bildirim ayarları nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Trendyol, sipariş durumları değiştiğinde buraya yazdığınız adrese bildirim gönderir; sistem siparişleri bu bildirimlerle günceller. Adres veya olay seçimi yanlışsa güncellemeler sisteme ulaşmaz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Trendyol - Sipariş Bildirim Ayarları'),
    body: t(`${G}.regions.body`, 'Bildirim adresi, olaylar ve durum'),
    footer: t(`${G}.regions.footer`, 'Kapat / Yenile / Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Mevcut kaydı kontrol edin'),
      text: t(`${G}.s1.text`, 'Pencere açılınca Trendyol\'da kayıtlı bildirimler okunur ve tercihen aktif olan kayıt forma doldurulur. Liste okunamazsa kırmızı kutuda nedeni yazar (ör. kimlik doğrulama hatası: API key, API secret ve Seller ID\'yi entegrasyon ayarından kontrol edin).'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Bildirim adresini girin'),
      text: t(`${G}.s2.text`, '"Bildirim adresi" zorunludur ve http:// veya https:// ile başlamalıdır (örnek: https://ornek.com/api/order-webhook). Bu adres size verilen sipariş bildirimi adresi olmalıdır; yanlış adrese giden bildirimler siparişleri güncellemez.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Bildirim olaylarını seçin'),
      text: t(`${G}.s3.text`, '"Bildirim olayları (durum)" listesinden hangi durum değişikliklerinin bildirileceğini işaretleyin: Sipariş oluştu, Hazırlanıyor, Faturalandı, Kargoya verildi, Teslim edildi, İptal edildi, Paketlenmedi, Tedarik edilemedi, İade edildi. Hiçbirini seçmezseniz kutuda "Tüm durumlar" yazar.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Aktif / pasif durumu'),
      text: t(`${G}.s4.text`, '"Bildirim aktif mi?" anahtarı kaydın açık olup olmadığını belirler. Aktif kaydettiğinizde Trendyol\'daki diğer aktif bildirim kayıtları pasife alınır; böylece tek adres çalışır.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin'),
      text: t(`${G}.s5.text`, '"Kaydet" aynı adres Trendyol\'da kayıtlıysa o kaydı günceller, yoksa yeni kayıt açar; ardından liste yeniden okunur ve "Bildirim ayarları kaydedildi." yazar. "Yenile" kayıtları Trendyol\'dan yeniden okur.'),
      tips: [
        t(`${G}.s5.tip1`, 'Pencerede ayrı bir test düğmesi yoktur. Kaydettikten sonra Trendyol\'da bir sipariş durumu değiştiğinde siparişin sistemde güncellendiğini kontrol edin.'),
      ],
    },
  ],
});
